<template>
  <div class="flex flex-wrap mb-2" style="position:relative" :style="guideStep >= 7 && guideStep <= 12 && !isAreadlyOpenShowTargetKW ? { zIndex: 100 } : null">
    <loading :active="!this.showKeywordMix"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6">
      <div>
        <span v-if="!editPageType" class="text-red-500">*</span>
        <span class="text-grap-700 align-middle">{{lang['components']['Event']['KeywordMix']['kw_title']}}</span>
        <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip="'精準興趣廣告組合與關鍵字'"></i> -->
        <button
          v-if="false"
          id="keywordMix"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
          @click="teachVideo()"
        >
          {{lang['components']['Event']['KeywordMix']['video_teaching']}}
        </button>
      </div>
      <div class="flex-1 space-y-4">
        <div class="space-y-2">
          <!-- <div>
            <span  class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['KeywordMix']['default_keyword']}}</span>
          </div> -->
          <div class="grid grid-cols-3">
            <div :class="{ 'cursor-not-allowed': editPageType === true }">
              <Dropdown v-model="selectedMainClass" :options="MainClasses" optionLabel="name" class="rounded-md w-full" :disabled="editPageType" />
            </div>
            <div class="col-span-2" :class="{ 'cursor-not-allowed': editPageType === true }">
              <TreeSelect
                v-model="selectedCategories"
                selectionMode="checkbox"
                :options="useCategories"
                :placeholder="defaultPlaceholder"
                class="rounded-md w-full mx-1"
                :disabled="editPageType"
                @before-hide="handleHide"
              />
            </div>
          </div>
          <!-- <div>
            <span  class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['KeywordMix']['product_url_title']}}</span>
          </div>
          <div class="flex">
            <div class="bg-white rounded-md flex items-center w-5/6 p-2 shadow-sm border border-gray-200" :class="{ 'ring-4 border-blue-400': guideStep === 7 }">
              <input type="text" :disabled="editPageType" v-model="viewDatalistData.product_url" class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                :placeholder="lang['components']['Event']['KeywordMix']['product_url_title_placeholder']">
            </div>
            <button
              v-if="!editPageType"
              class="text-white px-4  ml-4 w-auto whitespace-no-wrap rounded-xl transition duration-300 bg-blue-900" @click="url_interests();">{{lang['components']['Event']['KeywordMix']['analyze_button_text']}}</button>
          </div>
          <div v-if="!editPageType" class="flex flex-wrap bg-white w-full p-2 rounded-md border" :class="{ 'ring-4 border-blue-400': guideStep === 8 || guideStep === 9 }">
            <template v-for="(tag, index) in urlKeywords" :key="tag.id">
              <div class="rounded m-1 px-2 py-1 text-sm cursor-pointer" :class="[
                tag.checked? tag.is_used == true ? 'bg-yellow-500' :'bg-blue-400' : tag.is_used == true ? 'bg-yellow-100' :' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="keywords_click(tag.checked, index, tag.code)">
                {{ tag.name }}
              </div>
            </template>
          </div> -->
          <div v-if="!editPageType && this.afterInterests" class="pt-8">
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['KeywordMix']['more_keywords_title']}}</span>
            <a class="text-blue-400 align-middle text-sm underline ml-4 cursor-pointer" :class="{ 'ring-4 border-blue-400': guideStep === 11 }" @click="suggest()">{{lang['components']['Event']['KeywordMix']['keywords_suggest_title']}} >></a>
          </div>
          <div v-if="!editPageType && this.afterInterests" class="flex flex-wrap bg-white w-full p-2 rounded-md border">
            <template v-for="(tag, index) in keywords_suggest" :key="tag.id">
              <div class="rounded m-1 px-2 py-1 text-sm cursor-pointer" :class="[
                tag.checked? tag.is_used == true ? 'bg-yellow-500' :'bg-gray-900' : tag.is_used == true ? 'bg-yellow-100' :' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="keywords_suggest_click(tag.checked, index, tag.kw_id, tag.kw_name, tag.kw_type, tag.form)">
                {{ tag.kw_name }}
              </div>
            </template>
          </div>
          <div v-if="!editPageType && this.afterInterests" class="flex pt-4">
            <span class="text-grap-400 text-sm w-autor">{{lang['components']['Event']['KeywordMix']['search_keywords_info']}}</span>
            <!-- 新手教學 -->
            <div class="ml-4 w-full" :class="{ 'ring-4 border-blue-400': guideStep === 12 }">
              <div
                class="flex p-2 w-full bg-white rounded-md items-center shadow-sm border border-gray-200"
              >
                <i class="pi pi-search"></i>
                <input
                  :disabled="editPageType"
                  v-model="search_keyword"
                  type="search"
                  class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
                  v-on:keyup="keyup_get_data();"
                />
              </div>
              <Listbox
                v-model="country"
                :options="countries"
                optionLabel="kw_name"
                optionValue="kw_id"
                class="mt-2 w-full rounded-md"
                emptyMessage="Loading..."
                v-if="search_keyword.length > 0"
              />
            </div>
            <!-- <div class=" bg-white rounded-md flex items-center w-full p-2 ml-4 shadow-sm border border-gray-200">
              <i class="pi pi-search"></i>
              <input type="search" class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent" v-model="search_keyword" v-on:keyup="test_keyup();">
            </div> -->
          </div>
          <!-- <Listbox v-model="country" :options="countries" optionLabel="name" optionValue="code" class="w-3/4 rounded-md"
            v-if="search_keyword.length > 0" /> -->
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;">
      <div class="flex flex-col bg-white rounded-xl space-y-4 p-4">
        <span class="text-gray-700">{{lang['components']['Event']['KeywordMix']['select_keywords']}}</span>
        <span class="text-gray-300 text-sm">{{lang['components']['Event']['KeywordMix']['select_keywords_num_info']}}</span>
        <div class="flex flex-col bg-white w-full p-2 rounded-xl border h-56 overflow-y-auto">
          <span v-if="viewDatalistData.creator_action_categories.length > 0">創作者互動</span>
          <template v-for="(tag, index) in viewDatalistData.creator_action_categories" :key="tag.kw_id">
            <!-- <div class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="tag.checked = !tag.checked" v-if="tag.checked">
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" style="fontSize: 0.8rem"></i>
            </div> -->
            <div class="flex justify-between rounded m-1 px-2 py-1 text-sm w-none bg-gray-900 text-white" :class="{ 'cursor-not-allowed': editPageType === true, 'cursor-pointer': editPageType === false }" @click="un_tiktok_keyword_select(tag.kw_id, tag.kw_type, tag.form)">
              <span>{{ tag.kw_name }}</span>
              <i class="pi pi-times mt-1" v-if="!editPageType" style="fontSize: 0.8rem"></i>
            </div>
          </template>
          <span v-if="viewDatalistData.interest_categories.length > 0">興趣</span>
          <template v-for="(tag, index) in viewDatalistData.interest_categories" :key="tag.kw_id">
            <!-- <div class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="tag.checked = !tag.checked" v-if="tag.checked">
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" style="fontSize: 0.8rem"></i>
            </div> -->
            <div class="flex justify-between rounded m-1 px-2 py-1 text-sm w-none bg-gray-900 text-white" :class="{ 'cursor-not-allowed': editPageType === true, 'cursor-pointer': editPageType === false }" @click="un_tiktok_keyword_select(tag.kw_id, tag.kw_type, tag.form)">
              <span>{{ tag.kw_name }}</span>
              <i class="pi pi-times mt-1" v-if="!editPageType" style="fontSize: 0.8rem"></i>
            </div>
          </template>
          <span v-if="viewDatalistData.video_action_categories.length > 0">影片互動</span>
          <template v-for="(tag, index) in viewDatalistData.video_action_categories" :key="tag.kw_id">
            <!-- <div class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="tag.checked = !tag.checked" v-if="tag.checked">
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" style="fontSize: 0.8rem"></i>
            </div> -->
            <div class="flex justify-between rounded m-1 px-2 py-1 text-sm w-none bg-gray-900 text-white" :class="{ 'cursor-not-allowed': editPageType === true, 'cursor-pointer': editPageType === false }" @click="un_tiktok_keyword_select(tag.kw_id, tag.kw_type, tag.form)">
              <span>{{ tag.kw_name }}</span>
              <i class="pi pi-times mt-1" v-if="!editPageType" style="fontSize: 0.8rem"></i>
            </div>
          </template>
          <span v-if="viewDatalistData.interest_keywords.length > 0">其他興趣</span>
          <template v-for="(tag, index) in viewDatalistData.interest_keywords" :key="tag.kw_id">
            <!-- <div class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="tag.checked = !tag.checked" v-if="tag.checked">
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" style="fontSize: 0.8rem"></i>
            </div> -->
            <div class="flex justify-between rounded m-1 px-2 py-1 text-sm w-none bg-gray-900 text-white" :class="{ 'cursor-not-allowed': editPageType === true, 'cursor-pointer': editPageType === false }" @click="un_tiktok_keyword_select(tag.kw_id, tag.kw_type, tag.form)">
              <span>{{ tag.kw_name }}</span>
              <i class="pi pi-times mt-1" v-if="!editPageType" style="fontSize: 0.8rem"></i>
            </div>
          </template>
          <span v-if="viewDatalistData.hashtags.length > 0">話題互動</span>
          <template v-for="(tag, index) in viewDatalistData.hashtags" :key="tag.kw_id">
            <!-- <div class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="tag.checked = !tag.checked" v-if="tag.checked">
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" style="fontSize: 0.8rem"></i>
            </div> -->
            <div class="flex justify-between rounded m-1 px-2 py-1 text-sm w-none bg-gray-900 text-white" :class="{ 'cursor-not-allowed': editPageType === true, 'cursor-pointer': editPageType === false }" @click="un_tiktok_keyword_select(tag.kw_id, tag.kw_type, tag.form)">
              <span>{{ tag.kw_name }}</span>
              <i class="pi pi-times mt-1" v-if="!editPageType" style="fontSize: 0.8rem"></i>
            </div>
          </template>
          <!-- <template v-for="(tag, index) in viewDatalistData.keywords" :key="tag.id">
            <div class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="tag.checked = !tag.checked" v-if="tag.checked">
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" style="fontSize: 0.8rem"></i>
            </div>
          </template>
          <template v-for="(tag, index) in keywords_suggest" :key="tag.id">
            <div class="flex justify-between rounded m-1 px-2 py-1 text-sm cursor-pointer w-none bg-blue-400 text-white" :class="[
                tag.checked? 'bg-blue-400' : ' bg-gray-200',
                tag.checked? 'text-white' : 'text-gray-400',
              ]" @click="tag.checked = !tag.checked" v-if="tag.checked">
              <span>{{ tag.name }}</span>
              <i class="pi pi-times mt-1" style="fontSize: 0.8rem"></i>
            </div>
          </template> -->
        </div>
      </div>
    </div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
  import Dropdown from 'primevue/dropdown';
  import TreeSelect from "primevue/treeselect";
  import CascadeSelect from "primevue/cascadeselect";
  import Listbox from 'primevue/listbox';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import Vue3DraggableResizable from 'vue3-draggable-resizable'
  import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'KeywordMix',
    components: {
      Dropdown,
      TreeSelect,
      CascadeSelect,
      Listbox,
      Loading
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: -1
      },
      // <!-- 新手教學 -->
      editPage: {
        type: Boolean
      },
      targetKW: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      itemsDatalist: {
        type: Object
      },
      lang: {
        type: Object
      },
      youtubeClose: {
        type: Boolean
      },
      returnKeywordsList: {
        type: Object
      },
      noTiktokData:{
        type: String
      }
    },
    data() {
      return {
        tags: [
          {
            id: 1,
            text: '選擇關鍵字1',
            checked: false
          },
          {
            id: 2,
            text: '選擇關鍵字2',
            checked: false
          },
          {
            id: 3,
            text: '選擇關鍵字3',
            checked: false
          },
          {
            id: 4,
            text: '選擇關鍵字4',
            checked: false
          },
          {
            id: 5,
            text: '選擇關鍵字5',
            checked: true
          },
          {
            id: 6,
            text: '選擇關鍵字6',
            checked: false
          },
          {
            id: 7,
            text: '選擇關鍵字7',
            checked: false
          },
          {
            id: 8,
            text: '選擇關鍵字8',
            checked: false
          },
          {
            id: 9,
            text: '選擇關鍵字9',
            checked: false
          },
          {
            id: 10,
            text: '選擇關鍵字10',
            checked: false
          },
        ],
        moreTags: [
          {
            id: 1,
            text: '選擇更多關鍵字1',
            checked: false
          },
          {
            id: 2,
            text: '選擇更多關鍵字2',
            checked: false
          },
          {
            id: 3,
            text: '選擇更多關鍵字3',
            checked: false
          }
        ],
        selectedMainClass: null,
        MainClasses:[
          { name: '創作者互動', code: 'creator_action_categories' },
          { name: '興趣', code: 'interest_categories' },
          { name: '影片互動', code: 'video_action_categories' }
        ],
        defaultKeySelect: null,
        defaultKeyList: [
          {
              name: 'Australia',
              code: 'AU',
              states: [
                  {
                      name: 'New South Wales',
                      cities: [
                          {cname: 'Sydney', code: 'A-SY'},
                          // {cname: 'Newcastle', code: 'A-NE'},
                          {
                            name: 'Newcastle',
                            district: [
                              { cname: 'Newcastle Area 1', code: 'A-NE-1' },
                              { cname: 'Newcastle Area 2', code: 'A-NE-2' },
                              { cname: 'Newcastle Area 3', code: 'A-NE-3' }
                            ]
                          },
                          {cname: 'Wollongong', code: 'A-WO'}
                      ]
                  },
                  {
                      name: 'Queensland',
                      cities: [
                          {cname: 'Brisbane', code: 'A-BR'},
                          {cname: 'Townsville', code: 'A-TO'}
                      ]
                  },
                  {
                      cname: 'Test Area',
                      code: 'TA'
                  },
              ]
          },
          {
              name: 'Canada',
              code: 'CA',
              states: [
                  {
                      name: 'Quebec',
                      cities: [
                          {cname: 'Montreal', code: 'C-MO'},
                          {cname: 'Quebec City', code: 'C-QU'}
                      ]
                  },
                  {
                      name: 'Ontario',
                      cities: [
                          {cname: 'Ottawa', code: 'C-OT'},
                          {cname: 'Toronto', code: 'C-TO'}
                      ]
                  },

              ]
          },
          {
              name: 'United States',
              code: 'US',
              states: [
                  {
                      name: 'California',
                      cities: [
                          {cname: 'Los Angeles', code: 'US-LA'},
                          {cname: 'San Diego', code: 'US-SD'},
                          {cname: 'San Francisco', code: 'US-SF'}
                      ]
                  },
                  {
                      name: 'Florida',
                      cities: [
                          {cname: 'Jacksonville', code: 'US-JA'},
                          {cname: 'Miami', code: 'US-MI'},
                          {cname: 'Tampa', code: 'US-TA'},
                          {cname: 'Orlando', code: 'US-OR'}
                      ]
                  },
                  {
                      name: 'Texas',
                      cities: [
                          {cname: 'Austin', code: 'US-AU'},
                          {cname: 'Dallas', code: 'US-DA'},
                          {cname: 'Houston', code: 'US-HO'}
                      ]
                  }
              ]
          },
          {
              cname: 'Taiwan',
              code: 'TW'
          }
        ],
        search_keyword: '',
        keywords_suggest: [],
        urlKeywords: [],
        keywordsCheckedList: [],
        country: null,
        countries: null,
        selectCountries: [],
        mark_data: [],
        showKeywordMix: true,
        afterInterests: true,
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        src: "https://www.youtube.com/watch?v=VMMjP-UF6BY",
        vars: {
          rel: 0,
          start: 0,
          end: 0,
        },
        view_youtube: false,
        dataCategories:[],
        dataCategoriesMark:[],
        dataCategoriesParents:[],
        selectedCategories: {},
        useCategories:[],
        defaultPlaceholder: '請先選擇左側的興趣關鍵字類別',
        base_data: []
      }
    },
    created() {
      axios
        .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_keywords_tree_lists.php', Qs.stringify({
          s_code: this.$route.params.id,
          advertiser_id: this.$route.params.adaccount_id,
          keyword_ids: []
        }))
        .then((response) => {
          console.log(response);
          if(response.data.status == 'success'){
            // this.urlKeywords = response.data.return_data
            // this.urlKeywords = this.urlKeywords.concat(response.data.return_data);

            this.dataCategories = response.data.return_data;
            this.dataCategoriesMark = response.data.keywords_mark;
            this.dataCategoriesParents = response.data.keywords_parents;
            this.base_data = response.data.base_data;
            this.selectedMainClass = { name: '創作者互動', code: 'creator_action_categories' };
          }
        });
    },
    watch: {
      'youtubeClose':function(v){
        console.log('marketingmethod youtubeClose');
        console.log(v);

        let _tmpYoutubeType = v.split('_');

        console.log('_tmpYoutubeType');
        console.log(_tmpYoutubeType);

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);

        if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
          if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'keyword'){
            this.view_youtube = false
          }
        }

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);
      },
      country(v) {
        console.log('country');
        console.log(this.mark_data);
        console.log(v);
        var inArray = 0
        // console.log(this.keywords_suggest);

        for (let i = 0; i < this.keywords_suggest.length; i++) {
          if (this.keywords_suggest[i].kw_id === v) {
            inArray = 1
          }
        }

        if(inArray == 0 && v != null){
          this.keywords_suggest.push(this.mark_data[v])
        }

        this.search_keyword = '';

        this.$emit('childKeywordUrl', v);
      },
      'viewDatalistData': function(v){
        // console.log('viewDatalistData.product_url:' + v);
        console.log('viewDatalistData');
        console.log(v);
      },
      'viewDatalistData.product_url': function(v){
        // console.log('viewDatalistData.product_url:' + v);
        this.$emit('childKeywordUrl', v);
      },
      'viewDatalist.keyword_list': function(v){
        console.log('viewDatalistData.keyword_list:' + v);

        if(v != '' && v.length != null && typeof v != 'undefined'){
          if(v.length > 0){
            this.urlKeywords = v;

            this.afterInterests = true;
          }
        }
      },
      'viewDatalistData.selected_keywords_list': function(v){
        console.log('viewDatalistData.selected_keywords_list');
        console.log(v);

        console.log('b this.selectedCategories');
        console.log(this.selectedCategories);

        this.selectedCategories = v;

        console.log('a this.selectedCategories');
        console.log(this.selectedCategories);
      },
      'selectedMainClass': function(v){
        console.log('selectedMainClass');
        console.log(v);

        this.useCategories = this.dataCategories[v.code];

        console.log('this.useCategories');
        console.log(this.useCategories);

        if(this.useCategories != null && this.useCategories != '' && typeof this.useCategories != 'undefined'){
          if(this.useCategories.length > 0){
            this.defaultPlaceholder = this.lang['components']['Event']['KeywordMix']['watch']['selectedMainClass']['default_placeholder'];
          }
        }
      },
      'selectedCategories': function(v){
        console.log('selectedCategories');
        console.log(v);

        let _tmp_selected_data = [];
        let partial_data = [];
        let checked_data = [];
        let checked_sub_data = [];
        let checked_pare_data = [];
        let _fin_checked_data = [];
        let _tmp_remove = [];

        Object.keys(v).forEach(key => {
          if(v[key].checked == true){
            checked_data.push(key);
          }

          if(v[key].partialChecked == true){
            partial_data.push(key);
          }

          _tmp_selected_data[key] = {checked: v[key].checked, partialChecked: v[key].partialChecked};
        });

        console.log('_tmp_selected_data');
        console.log(_tmp_selected_data);
        console.log('checked_data');
        console.log(checked_data);
        console.log('partial_data');
        console.log(partial_data);
        console.log('this.dataCategoriesMark');
        console.log(this.dataCategoriesMark);

        let _checked_data_length = checked_data.length;

        for(let i = 0; i < _checked_data_length; i++){
          if(this.dataCategoriesMark[checked_data[i]] != null){
            console.log('有子類別');
            let _tmp_sub_data = this.dataCategoriesMark[checked_data[i]];
            console.log(_tmp_sub_data);

            let _sub_length = _tmp_sub_data.length;
            let _checked_sub_length = 0;
            //判斷子類別是不是全選狀態
            for(let j = 0; j < _sub_length; j++){
              if(_tmp_selected_data[_tmp_sub_data[j]].checked == true){
                _checked_sub_length++;
              }
            }

            console.log(_sub_length +'=='+ _checked_sub_length);

            if(_sub_length == _checked_sub_length){
              //子類別是全選狀態：只顯示父類別
              console.log('子類別是全選狀態：只顯示父類別');
              _fin_checked_data.push(checked_data[i]);
              for(let j = 0; j < _sub_length; j++){
                if(_tmp_selected_data[_tmp_sub_data[j]].checked == true){
                  _tmp_remove.push(_tmp_sub_data[j]);
                }
              }
            } else {
              //子類別並沒有全選狀態：把有勾選的類別顯示出來
              console.log('子類別並沒有全選狀態：把有勾選的類別顯示出來');
              for(let j = 0; j < _sub_length; j++){
                if(_tmp_selected_data[_tmp_sub_data[j]].checked == true){
                  _fin_checked_data.push(_tmp_sub_data[j]);
                }
              }
            }
          } else {
            console.log('沒子類別');
            _fin_checked_data.push(checked_data[i]);
          }

          console.log('for _fin_checked_data');
          console.log(_fin_checked_data);
        }

        console.log('_fin_checked_data');
        console.log(_fin_checked_data);

        console.log('_tmp_remove');
        console.log(_tmp_remove);

        const differenceArray = _fin_checked_data.filter(item => !_tmp_remove.includes(item));

        console.log('differenceArray');
        console.log(differenceArray);

        // var size = Object.keys(v).length;
        // console.log(size);

        let _tmp_keywords_suggest = this.keywords_suggest;
        let _tmp_keywords_suggest_length = this.keywords_suggest.length;
        let _data_keywords_suggest = [];

        for(let j = 0; j < _tmp_keywords_suggest.length; j++){
          _data_keywords_suggest[_tmp_keywords_suggest[j].kw_id] = _tmp_keywords_suggest[j].kw_name;
        }



        this.viewDatalistData.creator_action_categories = [];
        this.viewDatalistData.interest_categories = [];
        this.viewDatalistData.video_action_categories = [];
        // this.viewDatalistData.interest_keywords = [];
        // this.viewDatalistData.hashtags = [];

        let _tmp_fin_checked_data_length = differenceArray.length;
        let _checked_creator_action_categories = [];
        let _checked_interest_categories = [];
        let _checked_video_action_categories = [];

        for(let i = 0; i < _tmp_fin_checked_data_length; i++){
          let _tmp_data = differenceArray[i].split('|');
          let _tmp_kw_id = _tmp_data[0];
          let _tmp_kw_type = _tmp_data[1];

          if(_tmp_kw_type == 'creator_action_categories' || _tmp_kw_type == 'interest_categories' || _tmp_kw_type == 'video_action_categories' ){
            let _tmp_kw_name = this.base_data[differenceArray[i]].name;

            if(_tmp_kw_type == 'creator_action_categories'){
              this.viewDatalistData.creator_action_categories.push({kw_id: _tmp_kw_id, kw_name: _tmp_kw_name, kw_type: _tmp_kw_type, form: 'list'});
              _checked_creator_action_categories.push(_tmp_kw_id);
            }

            if(_tmp_kw_type == 'interest_categories'){
              this.viewDatalistData.interest_categories.push({kw_id: _tmp_kw_id, kw_name: _tmp_kw_name, kw_type: _tmp_kw_type, form: 'list'});
              _checked_interest_categories.push(_tmp_kw_id);
            }

            if(_tmp_kw_type == 'video_action_categories'){
              this.viewDatalistData.video_action_categories.push({kw_id: _tmp_kw_id, kw_name: _tmp_kw_name, kw_type: _tmp_kw_type, form: 'list'});
              _checked_video_action_categories.push(_tmp_kw_id);
            }
          } else {
            console.log('_data_keywords_suggest');
            console.log(_data_keywords_suggest);

            if(_tmp_kw_type == 'interest_keywords'){
              this.viewDatalistData.interest_keywords.push({kw_id: _tmp_kw_id, kw_name: _data_keywords_suggest[_tmp_kw_id], kw_type: _tmp_kw_type, form: 'list'});
            }

            if(_tmp_kw_type == 'hashtags'){
              this.viewDatalistData.hashtags.push({kw_id: _tmp_kw_id, kw_name: _data_keywords_suggest[_tmp_kw_id], kw_type: _tmp_kw_type, form: 'list'});
            }
          }
        }

        if(_tmp_keywords_suggest_length > 0){
          for(let k = 0; k < _tmp_keywords_suggest_length; k++){
            if(this.keywords_suggest[k].kw_type == 'creator_action_categories'){
              if(_checked_creator_action_categories.includes(this.keywords_suggest[k].kw_id) == true){
                this.keywords_suggest[k].checked = true;
              } else {
                this.keywords_suggest[k].checked = false;
              }
            }

            if(this.keywords_suggest[k].kw_type == 'interest_categories'){
              if(_checked_interest_categories.includes(this.keywords_suggest[k].kw_id) == true){
                this.keywords_suggest[k].checked = true;
              } else {
                this.keywords_suggest[k].checked = false;
              }
            }

            if(this.keywords_suggest[k].kw_type == 'video_action_categories'){
              if(_checked_video_action_categories.includes(this.keywords_suggest[k].kw_id) == true){
                this.keywords_suggest[k].checked = true;
              } else {
                this.keywords_suggest[k].checked = false;
              }
            }
          }
        }

        console.log('this.viewDatalistData.creator_action_categories');
        console.log(this.viewDatalistData.creator_action_categories);

        console.log('this.viewDatalistData.interest_categories');
        console.log(this.viewDatalistData.interest_categories);

        console.log('this.viewDatalistData.video_action_categories');
        console.log(this.viewDatalistData.video_action_categories);

        console.log('this.viewDatalistData.interest_keywords');
        console.log(this.viewDatalistData.interest_keywords);

        console.log('this.viewDatalistData.hashtags');
        console.log(this.viewDatalistData.hashtags);

        console.log('fin selectedCategories');
        console.log(v);

        this.$emit('childSelectedCategories', v);

        // Object.keys(v).forEach(key => {
        //   console.log(key, v[key]);

        //   let _tmp_data = key.split('|');
        //   let _tmp_kw_id = _tmp_data[0];
        //   let _tmp_kw_type = _tmp_data[1];
        //   let _tmp_kw_name = this.base_data[key].name;

        //   if(_tmp_kw_type == 'creator_action_categories'){
        //     this.viewDatalistData.creator_action_categories.push({kw_id: _tmp_kw_id, kw_name: _tmp_kw_name, kw_type: _tmp_kw_type});
        //   }

        //   if(_tmp_kw_type == 'interest_categories'){
        //     this.viewDatalistData.interest_categories.push({kw_id: _tmp_kw_id, kw_name: _tmp_kw_name, kw_type: _tmp_kw_type});
        //   }

        //   if(_tmp_kw_type == 'video_action_categories'){
        //     this.viewDatalistData.video_action_categories.push({kw_id: _tmp_kw_id, kw_name: _tmp_kw_name, kw_type: _tmp_kw_type});
        //   }
        // });
      },
      'returnKeywordsList': function(v){
        console.log('returnKeywordsList');
        this.selectedCategories = v;
      },
      'noTiktokData': function(v){
        console.log('noTiktokData');
        console.log(v);

        let _tmp = v.split('_');

        if(_tmp[0] == 'true'){
          console.log('_tmp[0]');
          console.log(_tmp[0]);

          this.MainClasses = [
            { name: '興趣', code: 'interest_categories' },
          ];

          this.selectedMainClass = { name: '興趣', code: 'interest_categories' };
        } else {
          this.MainClasses = [
            { name: '創作者互動', code: 'creator_action_categories' },
            { name: '興趣', code: 'interest_categories' },
            { name: '影片互動', code: 'video_action_categories' }
          ];

          this.selectedMainClass = { name: '創作者互動', code: 'creator_action_categories' };
        }
      }
    },
    methods: {
      onReady() {
        console.log('youtube');
        this.$refs.youtube.playVideo()
        // this.$refs.youtube.pauseVideo()
      },
      onStateChange(e){
        console.log(e);

        if(e.data == 0){
          this.view_youtube = false
        }
      },
      teachVideo(){
        this.$emit('checkClose')
        // let elem = document.getElementById('keywordMix');
        // let positio = this.getPosition(elem);
        // console.log('x:'+positio.x);
        // console.log('y:'+positio.y);

        // this.x = positio.x + parseInt(80);
        // this.y = positio.y

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;

        // console.log('windowWidth');
        // console.log(windowWidth);
        // console.log('windowHeight');
        // console.log(windowHeight);

        this.x = windowWidth - parseInt(390);
        this.y = windowHeight - parseInt(350);

        this.view_youtube = true;
        this.$emit('childYoutube', 'true_keyword')

        this.src = "https://www.youtube.com/watch?v=VMMjP-UF6BY"
        this.vars.start = 134
        this.vars.end = 239
      },
      getPosition(element) {
        let x = 0;
        let y = 0;

        while ( element ) {
          x += element.offsetLeft - element.scrollLeft + element.clientLeft;
          y += element.offsetTop - element.scrollLeft + element.clientTop;
          element = element.offsetParent;
        }

        return { x: x, y: y };
      },
      print(val) {
        console.log(val)
      },
      doDragging(){
        console.log('doDragging');
      },
      defaultGetValue(e){
        console.log(e);

        this.showKeywordMix = false;

        axios
          .post('https://test.autoturn.net/inside/api/campaign_form_default_keywords.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            industry: e.value.code
          }))
          .then((response) => {
            console.log(response);
            if(response.data.status == 'success'){
              // this.urlKeywords = response.data.return_data
              // this.urlKeywords = this.urlKeywords.concat(response.data.return_data);

              if(this.urlKeywords.length > 0){
                if(response.data.return_data.length > 0){
                  for(let i = 0; i < response.data.return_data.length; i++){
                    let itemKeyStatus = false;
                    for(let j = 0; j < this.urlKeywords.length; j++){
                      if(response.data.return_data[i].code == this.urlKeywords[j].code){
                        itemKeyStatus = true;
                      }
                    }

                    if(itemKeyStatus == false){
                      console.log('#1');
                      this.urlKeywords.push(response.data.return_data[i]);
                    }
                  }
                }
              } else {
                console.log('#2');
                this.urlKeywords = this.urlKeywords.concat(response.data.return_data);
              }

              console.log(this.urlKeywords);

              // console.log(this.urlKeywords);
              this.$emit('childUrlKeywordsList', this.urlKeywords)
            }

            this.showKeywordMix = true;
            this.afterInterests = true;
            this.defaultKeySelect = null;
          });

        // var inArray = 0
        // console.log(this.urlKeywords);

        // for (let i = 0; i < this.urlKeywords.length; i++) {
        //   if (this.urlKeywords[i].code === e.value.code) {
        //     inArray = 1
        //   }
        // }

        // if(inArray == 0 && e.value.code != null){
        //   let selectKey = {name: e.value.cname, code: e.value.code, type: 'test', is_used: false, checked: false};
        //   this.urlKeywords.push(selectKey);
        // }

        // this.showKeywordMix = true;
        // this.afterInterests = true;
        // this.defaultKeySelect = null;
      },
      keywords_click(checked, index, code){
        let inItem = false
        let itemLength = 0

        for (let k = 0; k < this.viewDatalistData.keywords.length; k++) {
          if (this.viewDatalistData.keywords[k].checked == true) {
            itemLength = parseInt(itemLength) + parseInt(1);
          }
        }

        if(checked == false){
          if(itemLength < 5){
            for (let i = 0; i < this.viewDatalistData.keywords.length; i++) {
              if (this.viewDatalistData.keywords[i].code === code) {
                this.viewDatalistData.keywords[i].checked = true
                this.urlKeywords[index].checked = true
                inItem = true
              }
            }

            if(inItem == false){
              this.viewDatalistData.keywords.push({
                name: this.urlKeywords[index].name,
                code: code,
                type: this.urlKeywords[index].type,
                checked: true
              });
              this.urlKeywords[index].checked = true
            }
          } else {
            Swal.fire(
                      this.lang['components']['Event']['KeywordMix']['methods']['keywords_click']['swal_title'],
                      this.lang['components']['Event']['KeywordMix']['methods']['keywords_click']['swal_text'],
                      "error"
                    )
          }
        } else {
          for(let j = 0; j < this.urlKeywords.length; j++){
            if(this.urlKeywords[j].code === code){
              this.urlKeywords[j].checked = false
              for (let i = 0; i < this.viewDatalistData.keywords.length; i++) {
                if (this.viewDatalistData.keywords[i].code === code) {
                  this.viewDatalistData.keywords[i].checked = false
                }
              }
            }
          }
        }
      },
      keywords_suggest_click(checked, index, id, name, type, form){
        console.log('keywords_suggest_click');
        console.log(checked);
        console.log(index);
        console.log(id);
        console.log(name);
        console.log(type);
        let _creator_action_categories_length = this.viewDatalistData.creator_action_categories.length;
        let _interest_categories_length = this.viewDatalistData.interest_categories.length;
        let _video_action_categories_length = this.viewDatalistData.video_action_categories.length;
        let _interest_keywords_length = this.viewDatalistData.interest_keywords.length;
        let _hashtags_length = this.viewDatalistData.hashtags.length;

        if((parseInt(_creator_action_categories_length) + parseInt(_interest_categories_length) + parseInt(_video_action_categories_length) + parseInt(_interest_keywords_length) + parseInt(_hashtags_length)) >= 5){
          Swal.fire(
                      this.lang['components']['Event']['KeywordMix']['methods']['keywords_suggest_click']['swal_title'],
                      this.lang['components']['Event']['KeywordMix']['methods']['keywords_suggest_click']['swal_text'],
                      "error"
                    )
        } else{
          let _in_array_status = 0;

          switch(type){
            case "creator_action_categories":
              let _tmp_creator_action_categories_length = this.viewDatalistData.creator_action_categories.length;

              _in_array_status = 0;
              for(let k = 0; k < _tmp_creator_action_categories_length; k++){
                console.log('this.viewDatalistData.creator_action_categories['+k+'].kw_id');
                if(id == this.viewDatalistData.creator_action_categories[k].kw_id){
                  _in_array_status = 1;
                }
              }

              if(_in_array_status == 0){
                let _tmp_keywords_suggest_length = this.keywords_suggest.length;

                for(let i = 0; i < _tmp_keywords_suggest_length; i++){
                  // console.log('this.keywords_suggest['+i+'].kw_id');
                  // console.log(this.keywords_suggest[i].kw_id);
                  if(id == this.keywords_suggest[i].kw_id){
                    this.keywords_suggest[i].checked = true;
                  }
                }

                this.viewDatalistData.creator_action_categories.push({'kw_id': id, 'kw_name': name, 'kw_type': type, 'form': form});

                console.log('this.viewDatalistData.creator_action_categories');
                console.log(this.viewDatalistData.creator_action_categories);
              }
              break;
            case "interest_categories":
              let _tmp_interest_categories_length = this.viewDatalistData.interest_categories.length;

              _in_array_status = 0;
              for(let k = 0; k < _tmp_interest_categories_length; k++){
                console.log('this.viewDatalistData.interest_categories['+k+'].kw_id');
                if(id == this.viewDatalistData.interest_categories[k].kw_id){
                  _in_array_status = 1;
                }
              }

              if(_in_array_status == 0){
                let _tmp_keywords_suggest_length = this.keywords_suggest.length;

                for(let i = 0; i < _tmp_keywords_suggest_length; i++){
                  // console.log('this.keywords_suggest['+i+'].kw_id');
                  // console.log(this.keywords_suggest[i].kw_id);
                  if(id == this.keywords_suggest[i].kw_id){
                    this.keywords_suggest[i].checked = true;
                  }
                }

                this.viewDatalistData.interest_categories.push({'kw_id': id, 'kw_name': name, 'kw_type': type, 'form': form});

                console.log('this.viewDatalistData.interest_categories');
                console.log(this.viewDatalistData.interest_categories);
              }
              break;
            case "video_action_categories":
              let _tmp_video_action_categories_length = this.viewDatalistData.video_action_categories.length;

              _in_array_status = 0;
              for(let k = 0; k < _tmp_video_action_categories_length; k++){
                console.log('this.viewDatalistData.video_action_categories['+k+'].kw_id');
                if(id == this.viewDatalistData.video_action_categories[k].kw_id){
                  _in_array_status = 1;
                }
              }

              if(_in_array_status == 0){
                let _tmp_keywords_suggest_length = this.keywords_suggest.length;

                for(let i = 0; i < _tmp_keywords_suggest_length; i++){
                  // console.log('this.keywords_suggest['+i+'].kw_id');
                  // console.log(this.keywords_suggest[i].kw_id);
                  if(id == this.keywords_suggest[i].kw_id){
                    this.keywords_suggest[i].checked = true;
                  }
                }

                this.viewDatalistData.video_action_categories.push({'kw_id': id, 'kw_name': name, 'kw_type': type, 'form': form});

                console.log('this.viewDatalistData.video_action_categories');
                console.log(this.viewDatalistData.video_action_categories);
              }
              break;
            case "interest_keywords":
              let _tmp_interest_keywords_length = this.viewDatalistData.interest_keywords.length;

              _in_array_status = 0;
              for(let k = 0; k < _tmp_interest_keywords_length; k++){
                console.log('this.viewDatalistData.interest_keywords['+k+'].kw_id');
                if(id == this.viewDatalistData.interest_keywords[k].kw_id){
                  _in_array_status = 1;
                }
              }

              if(_in_array_status == 0){
                let _tmp_keywords_suggest_length = this.keywords_suggest.length;

                for(let i = 0; i < _tmp_keywords_suggest_length; i++){
                  // console.log('this.keywords_suggest['+i+'].kw_id');
                  // console.log(this.keywords_suggest[i].kw_id);
                  if(id == this.keywords_suggest[i].kw_id){
                    this.keywords_suggest[i].checked = true;
                  }
                }

                this.viewDatalistData.interest_keywords.push({'kw_id': id, 'kw_name': name, 'kw_type': type, 'form': form});

                console.log('this.viewDatalistData.interest_keywords');
                console.log(this.viewDatalistData.interest_keywords);
              }
              break;
            case "hashtags":
              let _tmp_hashtags_length = this.viewDatalistData.hashtags.length;

              _in_array_status = 0;
              for(let k = 0; k < _tmp_hashtags_length; k++){
                console.log('this.viewDatalistData.hashtags['+k+'].kw_id');
                if(id == this.viewDatalistData.hashtags[k].kw_id){
                  _in_array_status = 1;
                }
              }

              if(_in_array_status == 0){
                let _tmp_keywords_suggest_length = this.keywords_suggest.length;

                for(let i = 0; i < _tmp_keywords_suggest_length; i++){
                  // console.log('this.keywords_suggest['+i+'].kw_id');
                  // console.log(this.keywords_suggest[i].kw_id);
                  if(id == this.keywords_suggest[i].kw_id){
                    this.keywords_suggest[i].checked = true;
                  }
                }

                this.viewDatalistData.hashtags.push({'kw_id': id, 'kw_name': name, 'kw_type': type, 'form': form});

                console.log('this.viewDatalistData.hashtags');
                console.log(this.viewDatalistData.hashtags);
              }
              break;
          }

          if(type == 'creator_action_categories' || type == 'interest_categories' || type == 'video_action_categories'){
            let _tmp_key = id+'|'+type;
            let _key_childs = this.dataCategoriesMark[_tmp_key];//本人有沒有小孩子
            let _id_parents = this.dataCategoriesParents[_tmp_key];//本人有沒有父母
            let _id_parents_childs = this.dataCategoriesMark[_id_parents];//本人有沒有兄弟姐妹
            let _id_grand_parents = this.dataCategoriesParents[_id_parents];//本人有沒有曾祖父母
            let _id_grand_parents_childs = this.dataCategoriesMark[_id_grand_parents];//本人曾祖父母有沒有兄弟姐妹

            console.log('_key_childs');
            console.log(_key_childs);
            console.log('_id_parents');
            console.log(_id_parents);
            console.log('_id_parents_childs');
            console.log(_id_parents_childs);
            console.log('_id_grand_parents');
            console.log(_id_grand_parents);
            console.log('_id_grand_parents_childs');
            console.log(_id_grand_parents_childs);
            console.log('b this.selectedCategories');
            console.log(this.selectedCategories);

            this.selectedCategories[_tmp_key] = {checked: true, partialChecked: false};

            //id若有小孩子，則預設全選
            if(typeof _key_childs !== 'undefined'){
              let _key_childs_length = _key_childs.length;
              if(_key_childs_length > 0){
                for(let i = 0; i < _key_childs_length; i++){
                  this.selectedCategories[_key_childs[i]] = {checked: true, partialChecked: false};
                  console.log(this.selectedCategories[_key_childs[i]]);

                  if(typeof this.dataCategoriesMark[_key_childs[i]] !== 'undefined'){
                    let _id_parents_childs_s = this.dataCategoriesMark[_key_childs[i]];
                    let _id_parents_childs_s_length = _id_parents_childs_s.length;

                    console.log('_id_parents_childs_s');
                    console.log(_id_parents_childs_s);

                    if(_id_parents_childs_s_length > 0){
                      for(let k = 0; k < _id_parents_childs_s_length; k++){
                        this.selectedCategories[_id_parents_childs_s[k]] = {checked: true, partialChecked: false};
                      }
                    }
                  }
                }
              }
            }

            let _tmp_selectedCategories_data = {};
            let _tmp_selected_data = [];
            Object.keys(this.selectedCategories).forEach(key => {
              _tmp_selectedCategories_data[key] = {checked: this.selectedCategories[key].checked, partialChecked: this.selectedCategories[key].partialChecked};
              _tmp_selected_data[key] = {checked: this.selectedCategories[key].checked, partialChecked: this.selectedCategories[key].partialChecked};
            });

            //父類別若有小孩，則先確認自己的兄弟姐妹，有沒有已勾選的狀態，若都勾選，則父類別的checked為true，否則partialChecked為true
            if(typeof _id_parents_childs !== 'undefined'){
              console.log('_tmp_selected_data');
              console.log(_tmp_selected_data);
              let _id_parents_childs_length = _id_parents_childs.length;
              let _id_parents_childs_checked_array = [];
              for(let i = 0; i < _id_parents_childs_length; i++){
                console.log('_id_parents_childs['+i+']');
                console.log(_id_parents_childs[i]);
                if(typeof _tmp_selected_data[_id_parents_childs[i]] !== 'undefined'){
                  if(_tmp_selected_data[_id_parents_childs[i]].checked == true){
                    _id_parents_childs_checked_array.push(_id_parents_childs[i]);
                  }
                }
              }

              console.log('_id_parents_childs_length == _id_parents_childs_checked_array.length');
              console.log(_id_parents_childs_length+' == '+ _id_parents_childs_checked_array.length);
              if(_id_parents_childs_length == _id_parents_childs_checked_array.length){
                _tmp_selectedCategories_data[_id_parents] = {checked: true, partialChecked: false};
              } else {
                _tmp_selectedCategories_data[_id_parents] = {checked: false, partialChecked: true};
              }

              if(typeof _id_grand_parents_childs !== 'undefined'){
                let _id_grand_parents_childs_length = _id_grand_parents_childs.length;
                let _id_grand_parents_childs_checked_array = [];
                for(let i = 0; i < _id_grand_parents_childs_length; i++){
                  console.log('_id_grand_parents_childs['+i+']');
                  console.log(_id_grand_parents_childs[i]);
                  if(typeof _tmp_selected_data[_id_grand_parents_childs[i]] !== 'undefined'){
                    if(_tmp_selected_data[_id_grand_parents_childs[i]].checked == true){
                      _id_grand_parents_childs_checked_array.push(_id_grand_parents_childs[i]);
                    }
                  }
                }

                if(_id_grand_parents_childs_length == _id_grand_parents_childs_checked_array.length){
                  _tmp_selectedCategories_data[_id_grand_parents] = {checked: true, partialChecked: false};
                } else {
                  _tmp_selectedCategories_data[_id_grand_parents] = {checked: false, partialChecked: true};
                }
              }
            }

            console.log('a this.selectedCategories');
            console.log(this.selectedCategories);
            console.log('_tmp_selectedCategories_data');
            console.log(_tmp_selectedCategories_data);

            this.selectedCategories = _tmp_selectedCategories_data;

            // Object.keys(this.selectedCategories).forEach(key => {
            //   _tmp_selected_data[key] = {checked: this.selectedCategories[key].checked, partialChecked: this.selectedCategories[key].partialChecked};
            // });
          }
        }
      },
      un_tiktok_keyword_select(id, type, form){
        console.log('id + type + form');
        console.log(id+'|'+type+'|'+form);

        if(this.editPageType == false){
          let _tmp_selected_data = [];
          let _tmp_keywords_suggest_length = this.keywords_suggest.length;

          switch(type){
            case 'interest_keywords':
              let _tmp_interest_keywords_length = this.viewDatalistData.interest_keywords.length;

              if(_tmp_interest_keywords_length > 0){
                console.log(this.viewDatalistData.interest_keywords);
                // this.viewDatalistData.interest_keywords.filter(item => item.kw_id !== id);
                const update_interest_keywords = this.viewDatalistData.interest_keywords.filter(function(value) {
                  console.log(value.kw_id +' != '+ id);
                  return value.kw_id != id;
                });

                this.viewDatalistData.interest_keywords = update_interest_keywords;

                console.log('this.viewDatalistData.interest_keywords');
                console.log(this.viewDatalistData.interest_keywords);
              }

              if(_tmp_keywords_suggest_length > 0){
                for(let i = 0; i < _tmp_keywords_suggest_length; i++){
                  if(id == this.keywords_suggest[i].kw_id){
                    this.keywords_suggest[i].checked = false;
                  }
                }
              }
              break;
            case 'hashtags':
              let _tmp_hashtags_length = this.viewDatalistData.hashtags.length;

              if(_tmp_hashtags_length > 0){
                console.log(this.viewDatalistData.hashtags);
                // this.viewDatalistData.hashtags.filter(item => item.kw_id !== id);
                const update_hashtags = this.viewDatalistData.hashtags.filter(function(value) {
                  console.log(value.kw_id +' != '+ id);
                  return value.kw_id != id;
                });

                this.viewDatalistData.hashtags = update_hashtags;

                console.log('this.viewDatalistData.hashtags');
                console.log(this.viewDatalistData.hashtags);
              }

              if(_tmp_keywords_suggest_length > 0){
                for(let i = 0; i < _tmp_keywords_suggest_length; i++){
                  if(id == this.keywords_suggest[i].kw_id){
                    this.keywords_suggest[i].checked = false;
                  }
                }
              }
              break;
            case 'interest_categories':
              let _tmp_interest_categories_length = this.viewDatalistData.interest_categories.length;

              if(_tmp_interest_categories_length > 0){
                console.log(this.viewDatalistData.interest_categories);
                // this.viewDatalistData.interest_categories.filter(item => item.kw_id !== id);
                const update_interest_keywords = this.viewDatalistData.interest_categories.filter(function(value) {
                  console.log(value.kw_id +' != '+ id);
                  return value.kw_id != id;
                });

                this.viewDatalistData.interest_categories = update_interest_keywords;

                console.log('this.viewDatalistData.interest_categories');
                console.log(this.viewDatalistData.interest_categories);
              }

              if(_tmp_keywords_suggest_length > 0){
                for(let i = 0; i < _tmp_keywords_suggest_length; i++){
                  if(id == this.keywords_suggest[i].kw_id){
                    this.keywords_suggest[i].checked = false;
                  }
                }
              }
              break;
            case 'video_action_categories':
              let _tmp_video_action_categories_length = this.viewDatalistData.video_action_categories.length;

              if(_tmp_video_action_categories_length > 0){
                console.log(this.viewDatalistData.video_action_categories);
                // this.viewDatalistData.video_action_categories.filter(item => item.kw_id !== id);
                const update_hashtags = this.viewDatalistData.video_action_categories.filter(function(value) {
                  console.log(value.kw_id +' != '+ id);
                  return value.kw_id != id;
                });

                this.viewDatalistData.video_action_categories = update_hashtags;

                console.log('this.viewDatalistData.video_action_categories');
                console.log(this.viewDatalistData.video_action_categories);
              }

              if(_tmp_keywords_suggest_length > 0){
                for(let i = 0; i < _tmp_keywords_suggest_length; i++){
                  if(id == this.keywords_suggest[i].kw_id){
                    this.keywords_suggest[i].checked = false;
                  }
                }
              }
              break;
            case 'creator_action_categories':
              let _tmp_creator_action_categories_length = this.viewDatalistData.creator_action_categories.length;

              if(_tmp_creator_action_categories_length > 0){
                console.log(this.viewDatalistData.creator_action_categories);
                // this.viewDatalistData.creator_action_categories.filter(item => item.kw_id !== id);
                const update_hashtags = this.viewDatalistData.creator_action_categories.filter(function(value) {
                  console.log(value.kw_id +' != '+ id);
                  return value.kw_id != id;
                });

                this.viewDatalistData.creator_action_categories = update_hashtags;

                console.log('this.viewDatalistData.creator_action_categories');
                console.log(this.viewDatalistData.creator_action_categories);
              }

              if(_tmp_keywords_suggest_length > 0){
                for(let i = 0; i < _tmp_keywords_suggest_length; i++){
                  if(id == this.keywords_suggest[i].kw_id){
                    this.keywords_suggest[i].checked = false;
                  }
                }
              }
              break;
          }

          Object.keys(this.selectedCategories).forEach(key => {
            _tmp_selected_data[key] = {checked: this.selectedCategories[key].checked, partialChecked: this.selectedCategories[key].partialChecked};
          });

          let _tmp_update_data = {};
          let _remove_data = [id+'|'+type];

          let _tmp_sub_data = this.dataCategoriesMark[id+'|'+type];

          if(_tmp_sub_data != null){
            console.log(_tmp_selected_data);
            console.log(_tmp_sub_data);

            let _sub_length = _tmp_sub_data.length;

            for(let j = 0; j < _sub_length; j++){
              if(typeof _tmp_selected_data[_tmp_sub_data[j]] !== 'undefined'){
                if(_tmp_selected_data[_tmp_sub_data[j]].checked == true){
                  _remove_data.push(_tmp_sub_data[j]);
                }
              }
            }
          }

          let _tmp_id = id+'|'+type
          let _id_parents = this.dataCategoriesParents[_tmp_id];//本人有沒有父母
          let _id_parents_childs = this.dataCategoriesMark[_id_parents];//本人有沒有兄弟姐妹
          let _id_grand_parents = this.dataCategoriesParents[_id_parents];//本人有沒有曾祖父母
          let _id_grand_parents_childs = this.dataCategoriesMark[_id_grand_parents];//本人曾祖父母有沒有兄弟姐妹
          let _id_childs = this.dataCategoriesMark[_tmp_id];//本人有沒有兒女

          console.log('id');
          console.log(id);
          console.log('_id_parents');
          console.log(_id_parents);
          console.log('_id_parents_childs');
          console.log(_id_parents_childs);
          console.log('_id_grand_parents');
          console.log(_id_grand_parents);
          console.log('_id_grand_parents_childs');
          console.log(_id_grand_parents_childs);

          //父類別若有小孩，則先確認自己的兄弟姐妹，有沒有已勾選的狀態，若都勾選，則父類別的checked為true，否則partialChecked為true
          if(typeof _id_parents_childs !== 'undefined'){
            console.log('_tmp_selected_data');
            console.log(_tmp_selected_data);
            let _id_parents_childs_length = _id_parents_childs.length;
            let _id_parents_childs_checked_array = [];
            for(let i = 0; i < _id_parents_childs_length; i++){
              console.log('_id_parents_childs['+i+']');
              console.log(_id_parents_childs[i]);
              console.log('typeof _tmp_selected_data[_id_parents_childs[i]]');
              console.log(typeof _tmp_selected_data[_id_parents_childs[i]]);
              if(typeof _tmp_selected_data[_id_parents_childs[i]] === 'undefined'){
                // if(_tmp_selected_data[_id_parents_childs[i]].checked == true){
                  _id_parents_childs_checked_array.push(_id_parents_childs[i]);
                // }
              }
            }

            console.log('_id_parents_childs_length == _id_parents_childs_checked_array.length');
            console.log(_id_parents_childs_length+' == '+ _id_parents_childs_checked_array.length);
            let _remove_myself_id_parents_childs_length = parseInt(_id_parents_childs_length) - parseInt(1);
            if(_remove_myself_id_parents_childs_length == _id_parents_childs_checked_array.length){
              _remove_data.push(_id_parents);
            }

            console.log('a_remove_data');
            console.log(_remove_data);

            if(typeof _id_grand_parents_childs !== 'undefined'){
              let _id_grand_parents_childs_length = parseInt(_id_grand_parents_childs.length) - parseInt(1);
              let _id_grand_parents_childs_checked_array = [];
              for(let i = 0; i < _id_grand_parents_childs_length; i++){
                console.log('_id_grand_parents_childs['+i+']');
                console.log(_id_grand_parents_childs[i]);
                if(typeof _tmp_selected_data[_id_grand_parents_childs[i]] === 'undefined'){
                  // if(_tmp_selected_data[_id_grand_parents_childs[i]].checked == true){
                    _id_grand_parents_childs_checked_array.push(_id_grand_parents_childs[i]);
                  // }
                }
              }

              let _remove_myself_id_grand_parents_childs_length = parseInt(_id_grand_parents_childs_length) - parseInt(1);

              if(_remove_myself_id_grand_parents_childs_length == _id_grand_parents_childs_checked_array.length){
                _remove_data.push(_id_grand_parents);
              }
            }
          }

          let _id_childs_checked_array = [];

          console.log('_id_childs');
          console.log(_id_childs);

          if(typeof _id_childs !== 'undefined'){
            let _id_childs_length = _id_childs.length;

            for(let j = 0; j < _id_childs_length; j++){
              _remove_data.push(_id_childs[j]);

              let _id_childs_grandson = this.dataCategoriesMark[_id_childs[j]];//本人有沒有孫子孫女

              console.log('_id_childs_grandson');
              console.log(_id_childs_grandson);

              if(typeof _id_childs_grandson !== 'undefined'){
                let _id_childs_grandson_length = _id_childs_grandson.length;

                for(let k = 0; k < _id_childs_grandson_length; k++){
                  _remove_data.push(_id_childs_grandson[k]);
                }
              }
            }
          }

          console.log('b_remove_data');
          console.log(_remove_data);

          Object.keys(this.selectedCategories).forEach(key => {
            console.log(key, this.selectedCategories[key]);
            if(_remove_data.includes(key) == false){
              _tmp_update_data[key] = this.selectedCategories[key];
            }
          });

          console.log('_tmp_update_data');
          console.log(_tmp_update_data);

          console.log('b this.selectedCategories');
          console.log(this.selectedCategories);

          this.selectedCategories = _tmp_update_data;

          console.log('a this.selectedCategories');
          console.log(this.selectedCategories);
        }
      },
      url_interests () {
        let Expression = /http(s)?:\/\/[\w-\.]+(:\d+)?(\/[\w\/\.]*)?(\?\S*)?(#\S*)?/g;
        let objExp = new RegExp(Expression);
        let input_url = this.viewDatalistData.product_url;
        if(objExp.test(input_url) != true){
          Swal.fire({
            icon: 'error',
            title: this.lang['components']['Event']['KeywordMix']['methods']['url_interests']['swal_title'],
            text: this.lang['components']['Event']['KeywordMix']['methods']['url_interests']['swal_text'],
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: this.lang['components']['Event']['KeywordMix']['methods']['url_interests']['confirm_button']
          }).then((result) => {
            this.viewDatalistData.product_url = '';
          })
        } else {
          this.showKeywordMix = false;
            axios
              .post('https://test.autoturn.net/inside/api/campaign_url_interests.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                url: input_url,
                special_ad_category: this.viewDatalistData.special_ad_category,
                keywords: this.viewDatalistData.keywords
              }))
              .then((response) => {
                console.log(this.urlKeywords);
                console.log(response);
                if(response.data.status == 'success'){
                  // this.urlKeywords = response.data.return_data
                  // this.urlKeywords = this.urlKeywords.concat(response.data.return_data);

                  if(this.urlKeywords.length > 0){
                    if(response.data.return_data.length > 0){
                      for(let i = 0; i < response.data.return_data.length; i++){
                        let itemKeyStatus = false;
                        for(let j = 0; j < this.urlKeywords.length; j++){
                          if(response.data.return_data[i].code == this.urlKeywords[j].code){
                            itemKeyStatus = true;
                          }
                        }

                        if(itemKeyStatus == false){
                          console.log('#1');
                          this.urlKeywords.push(response.data.return_data[i]);
                        }
                      }
                    }
                  } else {
                    console.log('#2');
                    this.urlKeywords = this.urlKeywords.concat(response.data.return_data);
                  }

                  console.log(this.urlKeywords);

                  // console.log(this.urlKeywords);
                  this.$emit('childUrlKeywordsList', this.urlKeywords)
                }

                this.showKeywordMix = true;
                this.afterInterests = true;
              });
        }
      },
      suggest (){
        if(this.editPageType == false){
          // this.showKeywordMix = false;

          // console.log('this.viewDatalistData.keywords');
          // console.log(this.viewDatalistData.keywords);

          let _tmp_creator_action_categories = this.viewDatalistData.creator_action_categories;
          let _tmp_interest_categories = this.viewDatalistData.interest_categories;
          let _tmp_video_action_categories = this.viewDatalistData.video_action_categories;
          let _tmp_interest_keywords = this.viewDatalistData.interest_keywords;
          let _tmp_hashtags = this.viewDatalistData.hashtags;

          axios
            .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_keywords_suggest.php', Qs.stringify({
              s_code: this.$route.params.id,
              advertiser_id: this.$route.params.adaccount_id,
              creator_action_categories: _tmp_creator_action_categories,
              interest_categories: _tmp_interest_categories,
              video_action_categories: _tmp_video_action_categories,
              interest_keywords: _tmp_interest_keywords,
              hashtags: _tmp_hashtags,
            }))
            .then((response) => {
              console.log('tiktok_campaign_keywords_suggest');
              console.log(response);
              if(response.data.status == 'success'){
                let _tmp_creator_action_categories_length = this.viewDatalistData.creator_action_categories.length;
                let _tmp_interest_categories_length = this.viewDatalistData.interest_categories.length;
                let _tmp_video_action_categories_length = this.viewDatalistData.video_action_categories.length;
                let _tmp_interest_keywords_length = this.viewDatalistData.interest_keywords.length;
                let _tmp_hashtags_length = this.viewDatalistData.hashtags.length;
                let _tmp_keywords_suggest_length = this.keywords_suggest.length;
                let _tmp_return_length = response.data.return_data.length;

                let _creator_action_categories_id = [];
                if(_tmp_creator_action_categories_length > 0){
                  for(let i = 0; i < _tmp_creator_action_categories_length; i++){
                    _creator_action_categories_id.push(this.viewDatalistData.creator_action_categories[i].kw_id);
                  }
                }

                let _interest_categories_id = [];
                if(_tmp_interest_categories_length > 0){
                  for(let i = 0; i < _tmp_interest_categories_length; i++){
                    _interest_categories_id.push(this.viewDatalistData.interest_categories[i].kw_id);
                  }
                }

                let _video_action_categories_id = [];
                if(_tmp_video_action_categories_length > 0){
                  for(let i = 0; i < _tmp_video_action_categories_length; i++){
                    _video_action_categories_id.push(this.viewDatalistData.video_action_categories[i].kw_id);
                  }
                }

                let _interest_keywords_id = [];
                if(_tmp_interest_keywords_length > 0){
                  for(let i = 0; i < _tmp_interest_keywords_length; i++){
                    _interest_keywords_id.push(this.viewDatalistData.interest_keywords[i].kw_id);
                  }
                }

                let _hashtags_id = [];
                if(_tmp_hashtags_length > 0){
                  for(let i = 0; i < _tmp_hashtags_length; i++){
                    _hashtags_id.push(this.viewDatalistData.hashtags[i].kw_id);
                  }
                }

                let _keywords_suggest_id = [];
                if(_tmp_keywords_suggest_length > 0){
                  for(let i = 0; i < _tmp_keywords_suggest_length; i++){
                    _keywords_suggest_id.push(this.keywords_suggest[i].kw_id);
                  }
                }

                let use_keywords_suggest = [];
                for(let i = 0; i < _tmp_return_length; i++){
                  if(
                    (_creator_action_categories_id.includes(response.data.return_data[i].kw_id) == false) &&
                    (_interest_categories_id.includes(response.data.return_data[i].kw_id) == false) &&
                    (_video_action_categories_id.includes(response.data.return_data[i].kw_id) == false) &&
                    (_interest_keywords_id.includes(response.data.return_data[i].kw_id) == false) &&
                    (_hashtags_id.includes(response.data.return_data[i].kw_id) == false) &&
                    (_keywords_suggest_id.includes(response.data.return_data[i].kw_id) == false)
                  ){
                    use_keywords_suggest.push(response.data.return_data[i]);
                  }
                }

                if(this.keywords_suggest.length <= 0){
                  this.keywords_suggest = use_keywords_suggest;
                } else {
                  this.keywords_suggest = this.keywords_suggest.concat(use_keywords_suggest);
                }

                // this.$emit('update:itemsDatalist', response.data.return_data)

                // this.$emit('childKeywordsSuggestList', this.keywords_suggest)
              }

              // this.showKeywordMix = true;
            });
        }
      },
      keyup_get_data(){
        // console.log('search_keyword');
        // console.log(this.search_keyword);

        this.country = null
        this.countries = null

        axios
          .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_keywords_search.php', Qs.stringify({
            s_code: this.$route.params.id,
            advertiser_id: this.$route.params.adaccount_id,
            q: this.search_keyword
          }))
          .then((response) => {
            // console.log(response);
            if(response.data.status == 'success'){
              this.countries = response.data.return_data
              this.mark_data = response.data.mark_data
            }
          });
      },
      handleHide() {
        console.log('handleHide');

        console.log('this.viewDatalistData.creator_action_categories');
        console.log(this.viewDatalistData.creator_action_categories);
        console.log(this.viewDatalistData.creator_action_categories.length);

        console.log('this.viewDatalistData.interest_categories');
        console.log(this.viewDatalistData.interest_categories);
        console.log(this.viewDatalistData.interest_categories.length);

        console.log('this.viewDatalistData.video_action_categories');
        console.log(this.viewDatalistData.video_action_categories);
        console.log(this.viewDatalistData.video_action_categories.length);

        console.log('this.viewDatalistData.interest_keywords');
        console.log(this.viewDatalistData.interest_keywords);
        console.log(this.viewDatalistData.interest_keywords.length);

        console.log('this.viewDatalistData.hashtags');
        console.log(this.viewDatalistData.hashtags);
        console.log(this.viewDatalistData.hashtags.length);

        let _creator_action_categories_length = this.viewDatalistData.creator_action_categories.length;
        let _interest_categories_length = this.viewDatalistData.interest_categories.length;
        let _video_action_categories_length = this.viewDatalistData.video_action_categories.length;
        let _interest_keywords_length = this.viewDatalistData.interest_keywords.length;
        let _hashtags_length = this.viewDatalistData.hashtags.length;

        if((parseInt(_creator_action_categories_length) + parseInt(_interest_categories_length) + parseInt(_video_action_categories_length) + parseInt(_interest_keywords_length) + parseInt(_hashtags_length)) != 5){
          Swal.fire(
                      this.lang['components']['Event']['KeywordMix']['methods']['handleHide']['swal_title'],
                      this.lang['components']['Event']['KeywordMix']['methods']['handleHide']['swal_text'],
                      "error"
                    )
        }
      }
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      }
    }
  }
</script>
<style lang="scss" scope>

</style>
<style type="text/css">
  .p-checkbox .p-checkbox-box.p-highlight, .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {
    border-color: #111827;
    background: #111827;
  }

</style>